module.exports = __webpack_public_path__ + "static/img/12areaA_12.08d1a2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/12areaA_12.png
// module id = 801
// module chunks = 1